// What the host gives every module's pages (ADR 0064 step B), behind the Platform module's ports, loaded only when a
// page uses them: the Board (the Fleet module's request dialogs and calls, modules/platform/board.tsx) and the chat
// panel (the AI module's, modules/platform/chat-panel.tsx).
import * as React from 'react';
import { lazy } from 'react';
import { provideBoard } from '../modules/platform/index.ts';
import { provideChatPanel } from '../modules/platform/index.ts';
import {
  organizationAiCards,
  organizationGitCards,
  projectAiCards,
  projectRepositoryCards,
} from '../modules/platform/index.ts';

const fleet = () => import('../modules/fleet/index.ts').then((door) => door.pages['board/board-port']());

provideBoard({
  RequestDialog: lazy(() => fleet().then((m) => ({ default: m.BuildRequestDialog }))),
  ProjectAssistantDialog: lazy(() => fleet().then((m) => ({ default: m.ProjectAssistantDialog }))),
  create: async (slug, card) => (await fleet()).board.create(slug, card),
  list: async (q) => (await fleet()).board.list(q),
});

provideChatPanel(
  lazy(() =>
    import('../modules/ai/index.ts')
      .then((door) => door.pages['chat']())
      .then((m) => ({ default: m.CortexChatPanel })),
  ),
);

// The settings pages' slots (modules/platform/slots.tsx), in the order the pages show them.
const source = () => import('../modules/source/index.ts').then((door) => door.pages['git/settings-cards']());
const card = <P extends object>(load: () => Promise<React.ComponentType<P>>) =>
  lazy(async () => ({ default: await load() }));
projectRepositoryCards.provide(
  card(async () => {
    const { RepositoryCard } = await source();
    return ({ slug }: { slug: string }) => <RepositoryCard slug={slug} />;
  }),
);
projectRepositoryCards.provide(
  card(async () => {
    const { RepositoryCard } = await source();
    return ({ slug }: { slug: string }) => <RepositoryCard slug={slug} kind="governance" />;
  }),
);
projectRepositoryCards.provide(card(async () => (await source()).GovernancePromoteCard));
projectRepositoryCards.provide(card(async () => (await source()).RepoStatusCard));
projectRepositoryCards.provide(card(async () => (await source()).SdkVersionsCard));
projectRepositoryCards.provide(card(async () => (await source()).PullRequestSettingsCard));
projectRepositoryCards.provide(
  card(
    async () =>
      (await import('../modules/mini-apps/index.ts').then((door) => door.pages['apps/OutboundHostsCard']()))
        .OutboundHostsCard,
  ),
);
projectAiCards.provide(
  card(
    async () =>
      (await import('../modules/ai/index.ts').then((door) => door.pages['admin/AiToolPolicyCard']()))
        .AiToolPolicyCard,
  ),
);
organizationGitCards.provide(card(async () => (await source()).GitConnectionsCard));
organizationAiCards.provide(
  card(
    async () =>
      (await import('../modules/ai/index.ts').then((door) => door.pages['admin/AiSettingsCards']()))
        .OrgAiCard,
  ),
);
